export const SIGN_IN = 'user/sign_in';
export const SIGN_OUT = 'user/sign_out';
export const UPDATE_DATEPICKER = 'datepicker/updateDatepicker';
export const LOG_ACTIVE = 'user/log_active';
